import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.lpsysadmin.support.search');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

declare const wiz: any;

@Component({
    selector: 'wiz-portal-lpsysadmin-support-search',
template: templateSource || '',
    styles: [``],
})
export class PortalLpsysadminSupportSearchComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public q: string = '';
    public results: any = {};
    public loading: boolean = false;
    public searched: boolean = false;

    public groups = [
        { key: 'programs', label: '지원사업', icon: '🎯', linkPrefix: '/admin/support/programs/' },
        { key: 'applications', label: '신청기업', icon: '🏢', linkPrefix: '/admin/support/applications/' },
        { key: 'modules', label: '모듈', icon: '📚', linkPrefix: '' },
        { key: 'sessions', label: '회차', icon: '📅', linkPrefix: '' },
        { key: 'submissions', label: '제출물', icon: '📤', linkPrefix: '' },
        { key: 'feedbacks', label: '피드백', icon: '💬', linkPrefix: '' },
        { key: 'performances', label: '성과', icon: '📊', linkPrefix: '' },
    ];

    public async ngOnInit() { await this.service.init(); }

    public async runSearch() {
        if (!this.q || !this.q.trim()) return;
        this.loading = true; await this.service.render();
        const r = await wiz.call('search', { q: this.q });
        if (r.code == 200) this.results = r.data.results || {};
        else this.results = {};
        this.loading = false; this.searched = true;
        await this.service.render();
    }

    public groupResults(key: string): any[] { return this.results[key] || []; }
    public totalCount(): number {
        let n = 0;
        for (const g of this.groups) n += (this.results[g.key] || []).length;
        return n;
    }

    public goItem(group: string, item: any) {
        if (group === 'programs') this.service.href(`/admin/support/programs/${item.id}`);
        else if (group === 'applications') this.service.href(`/admin/support/applications/${item.id}`);
        else if (group === 'modules') this.service.href(`/admin/support/modules/${item.module_type}/${item.id}`);
        else if (group === 'sessions' && item.module_id) this.service.href(`/admin/support/modules/${item.module_type || 'etc'}/${item.module_id}`);
    }
}

export default PortalLpsysadminSupportSearchComponent;